import { useEffect } from 'react';

import { fetchRegionCodes } from '~/actions/addressActions';
import { useAppDispatch, useAppSelector } from '~/reducers';
import { getCountries, getUsStates, getCaProvinces } from '~/selectors/addressSelectors';
import { RegionCodesResponse } from '~/types/types';

let requestedRegionCodes = false;

const useRegionCodes = (): RegionCodesResponse => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!requestedRegionCodes) {
      requestedRegionCodes = true;
      dispatch(fetchRegionCodes());
    }
  }, [dispatch]);

  return {
    countries: useAppSelector(getCountries),
    usStates: useAppSelector(getUsStates),
    caProvinces: useAppSelector(getCaProvinces),
  };
};

export default useRegionCodes;
